module.exports = __webpack_public_path__ + "static/media/William H. Harrison - 1840.1a8ec0f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William H. Harrison - 1840.jpg
// module id = 566
// module chunks = 0